import { FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";
import { useTenantTranslation } from "src/hooks/formatters";
import { changeManualReviewAreaHotkeyBehaviour } from "src/store/slices/settings";
import { useAppDispatch } from "src/store/store";
import { useManualReviewAreaHotkeyBehaviour } from "src/hooks/settings";

export const ManualReviewAreaHotkeyModeToggle = () => {
  const { t } = useTenantTranslation();
  const dispatch = useAppDispatch();
  const behaviour = useManualReviewAreaHotkeyBehaviour();

  return (
    <Tooltip title={t("recordEventOnAreaKeyTooltip")}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={behaviour === "record"}
            onChange={(e) => {
              dispatch(
                changeManualReviewAreaHotkeyBehaviour(
                  e.target.checked ? "record" : "relabel"
                )
              );
            }}
            // A focused switch swallows the labelling hotkeys.
            onFocus={(e) => {
              e.target.blur();
            }}
          />
        }
        label={
          <Typography variant="body2" color="text.secondary">
            {t("recordEventOnAreaKey")}
          </Typography>
        }
        onMouseDown={(e) => {
          e.preventDefault();
        }}
        sx={{ ml: 0, mt: 0.5 }}
      />
    </Tooltip>
  );
};
